import { SxProps } from "@mui/material";

export const PreviewWrapper: SxProps = {
  height: "100%",
  width: "400px",
  overflow: "auto",
  bgcolor: "#fff",

  display: "flex",
  justifyContent: "center",
  py: 3,
  px: 1,
};

export const PreviewContainer: SxProps = {
  width: "100%",
  height: "100%",
  // border: "8px solid #000",
  borderRadius: "36px",
  flexShrink: 0,
  // pt: "20px",
  // pb: "15px",
  display: "flex",
  flexDirection: "column",
  scrollBehavior: "smooth",
  bgcolor: "#F2F2F7",
  px: 1,
  pt: 5,
  pb: 3,
  // position: "relative",

  // "&::before": {
  //   content: '""',
  //   position: "absolute",
  //   top: "-5px",
  //   left: "50%",
  //   transform: "translateX(-50%)",
  //   width: "80px",
  //   height: "15px",
  //   backgroundColor: "#000",
  //   borderBottomLeftRadius: "10px",
  //   borderBottomRightRadius: "10px",
  // },
};

export const ButtonContainer: SxProps = {
  pt: "10px",
  px: "15px",
  mt: "auto",
  display: "flex",
  justifyContent: "space-between",
  gap: 1,
};

export const QuestionCard: SxProps = {
  bgcolor: "#fff",
  borderRadius: "12px",
  boxShadow: "0px 0px 12px 0px rgba(0, 0, 0, 0.08)",
  p: 2,
};

export const sliderStyles: SxProps = {
  "& .MuiSlider-thumb": {
    height: 12,
    width: 12,
  },
  "& .MuiSlider-track": {
    border: "none",
  },
  "& .MuiSlider-rail": {
    backgroundColor: "#E5E7EB",
  },
  "& .MuiSlider-mark": {
    height: "22px",
    width: "1px",
    backgroundColor: "primary.main",
  },
};

export const itemStyle: SxProps = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  p: 1,
  width: "100%",
};
